import splitbee from '@splitbee/web';
import mixpanel from 'mixpanel-browser';
import { isProductionEnv } from '../utils/constants';

export const TRACK_EVENTS = {
  // init event
  MIXPANEL_START: 'MIXPANEL_START',

  // CODE MODAL
  COPY_CODE: 'COPY_CODE',
  OPEN_CODE_MODAL: 'OPEN_CODE_MODAL',
  CLOSE_CODE_MODAL: 'CLOSE_CODE_MODAL',
  EXPAND_CODE_MODAL: 'EXPAND_CODE_MODAL',
  MINIMISE_CODE_MODAL: 'MINIMISE_CODE_MODAL',
  MINIFY_CODE_MODAL: 'MINIFY_CODE_MODAL',
  CODE_TAB_: 'CODE_TAB_', // <+DATA/>

  // VIEW AREA
  VIEW_CUSTOM_SIZE_: 'VIEW_CUSTOM_SIZE_',

  // CUSTOMISE
  CHANGE_COLOR_: 'CHANGE_COLOR_', // <+DATA/>
  RESET_COLOR: 'RESET_COLOR',
  META_CONFIG_CHANGE_: 'META_CONFIG_CHANGE_', // <+DATA/>

  // BLOCK EDITOR
  RESET_BLOCK: 'RESET_BLOCK',
  ADD_BLOCK: 'ADD_BLOCK',
  CLEAR_BLOCK: 'CLEAR_BLOCK',
  DELETE_BLOCK: 'DELETE_BLOCK',
};

export const initAnalytics = () => {
  if (isProductionEnv) {
    splitbee.init();
    mixpanel.init('006dc65edbea169a9e80621ae15e7c87');
    mixpanel.track(TRACK_EVENTS.MIXPANEL_START);
  }
};
export const trackMixEvent = (eventName: string) => {
  if (isProductionEnv) {
    mixpanel.track(eventName);
  }
};
